import React from 'react';

import { createHtml, encode } from './utils';
import { ProtectedEmailProps } from './types';

const ProtectedEmail: React.FC<ProtectedEmailProps> = props => (
  <span
    className="__sizeid-protected-email"
    dangerouslySetInnerHTML={createHtml(encode(props.email), props.blank)}
  />
);

export default ProtectedEmail;
